/*
 * Filename: base-class.model.ts
 * Error store: This file represents the base classes.
 */

import { types, ModelInstanceTypeProps, ModelProperties } from 'mobx-state-tree';


export const BaseClassData = types.model({
    BaseClassObject: types.optional(types.frozen(), {}),
}).actions((self: ModelInstanceTypeProps<ModelProperties>) => ({

    setBaseClassObject(baseClassData: any) {
        self.BaseClassObject = baseClassData;
    }

}));
